export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/animation_for_kids.d478a41.svg";